/*
 * MentionsInput
 * Version 2.0
 * Written by: Kenneth Auchenberg
 *
 * Copyright (c) 2012 - Citrix Systems, Inc.
 *
 * Using underscore.js
 *
 * License: MIT License - http://www.opensource.org/licenses/mit-license.php
 */
define('lib/mentionsinput/MentionsInput',['require','jquery','underscore'],function(require) {

  var $ = require('jquery');
  var _ = require('underscore');

  // Settings
  var KEY = { BACKSPACE : 8, LEFT : 37, RIGHT : 39, HOME : 36, END : 35, DELETE : 46 }; // Keys "enum"

  var defaultSettings = {
    minChars                  : 2,
    elastic                   : true,
    insertSpaceAfterMention   : false,
    requireLeadingSpace       : true,
    templates                 : {
      wrapper                 : _.template('<div class="mentions-input-box"></div>'),
      mentionsOverlay         : _.template('<div class="mentions"><div></div></div>'),
      mention                 : {
        item: {
          syntax: _.template('#[<%- value %>](<%= type %>:<%= id %>)'),
          normal: _.template('#<%- value %>'),
          highlight: _.template('<strong><span>#<%= value %></span></strong>')
        },
        emoji: {
          syntax: _.template(':<%= id %>:'),
          normal: _.template(':<%= id %>:'),
          highlight: _.template('<strong><span>:<%= id %>:</span></strong>')
        },
        giphy: {
          syntax: _.template('$id:<%= id %>$'),
          normal: _.template('::id:<%= id %>::'),
          highlight: _.template('<strong><span>::id:<%= id %>::</span></strong>')
        },
        fallback: {
          syntax: _.template('@[<%- value %>](<%= type %>:<%= id %>)'),
          normal: _.template('@<%- value %>'),
          highlight: _.template('<strong><span>@<%= value %></span></strong>')
        }
      }
    },
    autoCompleter: {
      isVisible: 'isVisible',
      populate: 'populate',
      loading: $.noop,
      hide: 'hide'
    }
  };

  var Mention = function(value, id, type, position) {
     this.value = value;
     this.id = id;
     this.type = type;
     this.position = position;
  };

  var Selection = function(start, end) {
    this.start = start;
    this.end = end;
    this.length = end - start;
  };

  var MentionsInput = function (elmTarget, settings) {
    _.bindAll(this, 'onInputChange', 'checkQuery', 'onInputBoxFocus', 'onInputBoxBlur', 'getMentions',
        'val', 'search', 'adjustInput', 'replaceMentions', 'onInputBoxKeyDown', 'updateOverlay');
    this.mentions = [];

    this.initialize.apply(this, _.toArray(arguments));
  };

  _.extend(MentionsInput.prototype, {

    initialize : function(elmTarget, settings) {
      this.elmInputBox = elmTarget;
      this.settings = $.extend(true, {}, defaultSettings, settings);

      this.initTextarea();
      this.initMentionsOverlay();
      this.initAutocomplete();
    },

    destroy : function() {
      // Own elements are cleaned up when wrapper elements are removed from the DOM
      // but the autocompleter leaves element hanging and must be cleaned up manually.

      if (this.autoCompleter) {
        this.autoCompleter.destroy();
      }
    },

    initAutocomplete : function() {
      this.autoCompleter = this.settings.autoCompleter['initialize'](this.elmWrapperBox, this);
    },

    initTextarea : function() {
      this.elmInputWrapper = this.elmInputBox.parent();
      this.elmWrapperBox = $(this.settings.templates.wrapper());
      this.elmInputBox.wrapAll(this.elmWrapperBox);
      this.elmWrapperBox = this.elmInputWrapper.find('> div');

      this.elmInputBox.bind('keydown.mentionsInput', this.onInputBoxKeyDown);
      this.elmInputBox.bind('input.mentionsInput', this.onInputChange);
      this.elmInputBox.bind('blur.mentionsInput', this.onInputBoxBlur);
      this.elmInputBox.bind('focus.mentionsInput', this.onInputBoxFocus);

      // Elastic textareas, internal setting for the Dispora guys
      if( this.settings.elastic ) {
        this.elmInputBox.elastic();
      }

      this.oldInput = this.getInput();
    },

    initMentionsOverlay : function() {
      // Contruct element
      this.elmMentionsOverlay = $(this.settings.templates.mentionsOverlay());

      // Copy CSS properties to inner <div>
      var cssHash = {};
      var cssProperties = ['lineHeight', 'fontSize', 'fontFamily', 'fontWeight'];
      var i = cssProperties.length;
      while (i--) {
        cssHash[ cssProperties[i].toString() ] = this.elmInputBox.css( cssProperties[i].toString() );
      }
      this.elmMentionsOverlay.find('div').css( cssHash );

      // Append to wrapper
      this.elmMentionsOverlay.prependTo(this.elmWrapperBox);
    },

    _autoCompleterMethod: function(method) {
      var ref = this.settings.autoCompleter[method];

      if( _.isFunction(ref) ) {
        return ref();
      } else {
        return this.autoCompleter[ref]();
      }
    },

    search: function(query) {
      var self = this;

      this._autoCompleterMethod('loading');

      var requestFunc = this.settings.triggers[query.triggerChar];

      requestFunc.call(this, 'search', query.text, function (autoCompleteData) {
        self.autoCompleter.populate(autoCompleteData, query.text);
      });
    },

    hideAutoCompleter: function() {
      // immediate hiding after a click on the autocompleter item registers
      // a click on the parent (<body>), which triggeres outsideclick for the
      // preview panel, let's prevent by delaying.
      var self = this;

      _.delay(function() {
        self._autoCompleterMethod('hide');
      }, 100);
    },

    updateOverlay: function() {
      var overlay = this.computeText('highlight', true);
      overlay = overlay.replace(/\n/g, '<br />');
      overlay = overlay.replace(/ {2}/g, '&nbsp; ');
      this.elmMentionsOverlay.find('div').html(overlay);
    },

    addMention: function(mention) {
      var substitution = this.formatMention(mention, 'normal');
      
      var query = this.getQuery(substitution.length);
      if (!query) {
        return;
      }

      if (this.settings.insertSpaceAfterMention) {
        substitution += " ";
      }

      var newEnd = this.adjustInput(query.selection, substitution, true);
      this.mentions.push(new Mention(mention.value, mention.id, mention.type, new Selection(query.selection.start, newEnd)));

      this.hideAutoCompleter();
    },

    getInput: function() {
      return this.elmInputBox.val();
    },

    setInput: function(input) {
      this.elmInputBox.val(input);

      var self = this;
      _.defer(function() {
        self.elmInputBox.change();
      });
    },

    resetInput: function() {
      this.mentions = [];
      this.setInput("");
      this.updateOverlay();
    },

    adjustInput: function(selection, substitution, focus) {
      var oldInput = this.getInput();
      var newInput = oldInput.substr(0, selection.start) + substitution + oldInput.substr(selection.end);
      this.setInput(newInput);
      this.oldInput = newInput;

      this.adjustMentions({
        start: selection.start,
        added: substitution.length,
        removed: selection.length
      });
      
      _.defer(this.updateOverlay);

      var newEnd = selection.start + substitution.length;

      if (focus) {
        // Set correct focus and selection
        this.elmInputBox.focus();
        this.elmInputBox[0].setSelectionRange(newEnd, newEnd);
      }

      return newEnd;
    },
    
    formatMention: function(mention, templateName) {
      var typeTemplates = this.settings.templates.mention[mention.type];
      if (_.isUndefined(typeTemplates)) {
        typeTemplates = this.settings.templates.mention.fallback;
      }
      
      var template = typeTemplates[templateName];
      
      return template(mention);
    },

    computeText: function(templateName, escape) {
      var sortedMentions = _.sortBy(this.mentions, function(mention) {
        return mention.position.start;
      });

      var pos = 0;
      var input = this.getInput();
      var text = "";
      var self = this;

      sortedMentions.forEach(function (mention) {
        if (pos < mention.position.start) {
          var replacement = input.substr(pos, mention.position.start - pos);
          if (escape) {
            replacement = _.escape(replacement);
          }
          text += replacement;
        }

        text += self.formatMention(mention, templateName);
        pos = mention.position.end;
      });

      if (pos < input.length) {
        var replacement = input.substr(pos);
        if (escape) {
          replacement = _.escape(replacement);
        }
        text += replacement;
      }

      return text;
    },

    getQuery: function(maxLength) {
      var self = this;

      var input = this.getInput();
      var end = this.elmInputBox[0].selectionEnd;
      
      var mentionsBefore = _.filter(this.mentions, function(mention) {
        return mention.position.start < end;
      });
      
      var textStart = 0;
      if (!_.isEmpty(mentionsBefore)) {
        var lastMention = _.max(mentionsBefore, function(mention) {
          return mention.position.end;
        });
        
        textStart = lastMention.position.end;
      }
      
      var textToEnd = input.substr(textStart, end-textStart);

      var matches = [];
      _.each(_.keys(this.settings.triggers), function(triggerChar) {
        var start = textToEnd.lastIndexOf(triggerChar);
        if (start === -1) {
          // Trigger char not found
          return;
        }

        var selection = new Selection(start + textStart, end);
        if (selection.length < self.settings.minChars) {
          // Too short to be a query
          return;
        }

        if (!_.isUndefined(maxLength) && maxLength < selection.length - triggerChar.length) {
          // Longer than it should be
          return;
        }

        if (self.settings.requireLeadingSpace && start > 0) {
          var prevChar = textToEnd[start - 1];
          if (prevChar !== " " && prevChar !== "\n") {
            // If there is not a space or line break before the trigger char this
            // is not a query
            return;
          }
        }

        var text = textToEnd.substr(start + triggerChar.length);
        var spaceIdx = text.indexOf(" ");

        if (spaceIdx === 0) {
          // If the first text character is a space, there should be no search
          return;
        }

        if (spaceIdx !== -1 && !self._autoCompleterMethod('isVisible')) {
          // We added a space and the autocompleter was not open, so there is no
          // search
          return;
        }

        matches.push({
          triggerChar: triggerChar,
          selection: selection,
          text: text
        });
      });

      if (_.isEmpty(matches)) {
        return;
      }

      // Return the best match
      return _.max(matches, function(match) {
        // Prefer longer triggers
        return match.selection.length*match.triggerChar.length;
      });
    },

    checkQuery: function(e) {
      var query = this.getQuery();
      if (query) {
        _.defer(this.search, query);
      } else {
        this.hideAutoCompleter();
      }
    },

    adjustMentions: function(change) {
      var changed = false;

      var removed = 0;

      _.each(this.mentions.slice(0), function(mention, index) {
        if ((mention.position.start === change.start || mention.position.end === change.start + 1) &&
            change.removed === 1 && change.added === 0) {
          // Special case, removed the first letter of the mention, and no other change
          _.defer(this.adjustInput, new Selection(mention.position.start, mention.position.end - 1), "", true);
          changed = true;
          this.mentions.splice(index - removed, 1);
          removed += 1;
        } else if ((change.added > 0 && mention.position.start < change.start && mention.position.end > change.start) ||
            (mention.position.start < change.start + change.removed && mention.position.end > change.start)) {
          // Something inside the mention was added or removed
          changed = true;
          this.mentions.splice(index - removed, 1);
          removed += 1;
        } else if (mention.position.start >= change.start) {
          // Update the position
          changed = true;
          mention.position.start += change.added - change.removed;
          mention.position.end += change.added - change.removed;
        }
      }, this);

      return changed;
    },

    onInputBoxFocus: function() {
      _.defer(this.checkQuery);
    },

    onInputBoxBlur: function(e) {
      this.hideAutoCompleter();
    },

    onInputChange: function() {
      var input = this.getInput();
      var change = this.computeChange(this.oldInput, input);
      if (change) {
        var mentionsChanged = this.adjustMentions(change);
        if (mentionsChanged) {
          _.defer(this.updateOverlay);
        }
      }

      this.oldInput = input;

      this.checkQuery();
    },

    computeChange: function(a, b) {
      if (a === b) {
        return;
      }

      var leftIdx;
      for (leftIdx = 0; leftIdx < Math.min(a.length, b.length); leftIdx++) {
        if (a[leftIdx] !== b[leftIdx]) {
          break;
        }
      }

      var rightIdx;
      for (rightIdx = 0; rightIdx < Math.min(a.length, b.length) - leftIdx; rightIdx++) {
        if (a[a.length - rightIdx - 1] !== b[b.length - rightIdx - 1]) {
          break;
        }
      }

      return {
        start: leftIdx,
        added: b.length - rightIdx - leftIdx,
        removed: a.length - rightIdx - leftIdx
      };
    },

    replaceMentions: function(mentions) {
      for (var i = 0; i < mentions.length; i++) {
        var mention = mentions[i];

        var syntax = this.formatMention(mention, 'syntax');
        var normal = this.formatMention(mention, 'normal');

        while (true) {
          var idx = this.getInput().indexOf(syntax);
          if (idx === -1) {
            break;
          }

          var mentionEnd = this.adjustInput(new Selection(idx, idx + syntax.length), normal, false);
          this.mentions.push(new Mention(mention.value, mention.id, mention.type, new Selection(idx, mentionEnd)));
        }
      }
    },

    onInputBoxKeyDown: function(e) {
      // This also matches HOME/END on OSX which is CMD+LEFT, CMD+RIGHT
      if (e.keyCode == KEY.LEFT || e.keyCode == KEY.RIGHT || e.keyCode == KEY.HOME || e.keyCode == KEY.END ) {
        _.defer(this.checkQuery);
      }

      if (e.keyCode == KEY.BACKSPACE || e.keyCode == KEY.DELETE) {
        if (navigator.userAgent.indexOf("MSIE 9") > -1) {
          // IE9 doesn't fire the oninput event when backspace or delete is pressed. This causes the highlighting
          // to stay on the screen whenever backspace is pressed after a highlighed word. This is simply a hack
          // to force updateValues() to fire when backspace/delete is pressed in IE9.
          _.defer(this.onInputChange);
        }
      }
    },

    // External methods
    val: function() {
      return this.computeText('syntax', false);
    },

    getMentions: function() {
      return this.mentions;
    }

  });

  return MentionsInput;
});

